import React from 'react';
import {observer} from 'mobx-react';
import ExchangeLocationsStore from '../../stores/exchange-locations-store';
import ExchangeLocationsTableRow from './exchange-locations-table-row';
import FontBody2 from '../../../../../../components/fonts/font-body2/font-body2';
import {FONT_COLOR, FONT_VARIANT} from '../../../../../../components/fonts/font-props';
import useDashboardTranslation from '../../../../../../dashboard-translation/hooks/dashboard-translation-hook';
import {IExchangeLocationRuleRow} from '../../utilities/exchange-locations-table-builder';
import './exchange-locations-table.scss';
import Hr from "../../../../../../components/hr/hr";

interface IExchangeLocationsTableProps {
    store: ExchangeLocationsStore;
    onRowEdit: (row: IExchangeLocationRuleRow) => void;
}

/**
 * Table component for displaying exchange locations rules.
 * Shows warehouse-to-zones mappings with edit/delete actions.
 */
const ExchangeLocationsTable: React.FC<IExchangeLocationsTableProps> = observer(({store, onRowEdit}: IExchangeLocationsTableProps) => {

    const {getTranslation} = useDashboardTranslation();
    const pageScope = 'dashboard-settings-store';

    const locationsHeaderText = getTranslation('EXCHANGE_LOCATIONS_TABLE_HEADER_LOCATIONS', pageScope);
    const zonesHeaderText = getTranslation('EXCHANGE_LOCATIONS_TABLE_HEADER_ZONES', pageScope);
    const tableRows = store.getTableRows();

    return (
        <div className="exchange-locations-table">
            <div className="exchange-locations-table-header">
                <div className="exchange-locations-table-header-cell">
                    <FontBody2 variant={FONT_VARIANT.UPPERCASE} color={FONT_COLOR.PRIMARY3_50}>
                        {locationsHeaderText}
                    </FontBody2>
                </div>
                <div className="exchange-locations-table-header-cell">
                    <FontBody2 variant={FONT_VARIANT.UPPERCASE} color={FONT_COLOR.PRIMARY3_50}>
                        {zonesHeaderText}
                    </FontBody2>
                </div>
                <div className="exchange-locations-table-header-cell"></div>
            </div>
            <Hr/>
            <div className="exchange-locations-table-body">
                {tableRows.map((row, index) => (
                    <ExchangeLocationsTableRow
                        key={index}
                        row={row}
                        exchangeLocationsStore={store}
                        onEdit={onRowEdit}
                    />
                ))}
            </div>
        </div>
    );
});

export default ExchangeLocationsTable;

